import { create } from 'zustand';

interface ThemeChatState {
  logo: string | null;
  favicon: string | null;
  chatImage: string | null;
  iconShape: string | null;
  iconSize: any | null;

  defaultTheme: string;
  brandColor: string;
  inputBorderColor: string;
  font: string;
  fontWeight: string;
  pageBackground: string;
  pageText: string;
  backgroundImage: string;
  responseContainer: string;
  responseText: string;
  userContainer: string;
  userText: string;

  setLogo: (logo: string | null) => void;
  setFavicon: (favicon: string | null) => void;
  setChatImage: (chatImage: string | null) => void;
  setIconShape: (favicon: string | null) => void;
  setIconSize: (logo: any) => void;

  setDefaultTheme: (logo: string) => void;
  setBrandColor: (logo: string) => void;
  setInputBorderColor: (logo: string) => void;
  setFont: (logo: string) => void;
  setFontWeight: (logo: string) => void;
  setPageBackground: (logo: string) => void;
  setPageText: (logo: string) => void;
  setBackgroundImage: (logo: string | null) => void;
  setResponseContainer: (logo: string) => void;
  setResponseText: (logo: string) => void;
  setUserContainer: (logo: string) => void;
  setUserText: (logo: string) => void;
  // setGlobalData: (data: Omit<ThemeChatState, 'setGlobalData'>) => void;
}

const storeThemeChat = create<ThemeChatState>(set => ({
  logo: '',
  favicon: '',
  chatImage: '',
  iconShape: '',
  iconSize: '',
  defaultTheme: '',
  brandColor: '',
  inputBorderColor: '',
  font: '',
  fontWeight: '',
  pageBackground: '',
  pageText: '',
  backgroundImage: '',
  responseContainer: '',
  responseText: '',
  userContainer: '',
  userText: '',

  setLogo: (logo: string | null) => set({ logo }),
  setFavicon: (favicon: string | null) => set({ favicon }),
  setChatImage: (chatImage: string | null) => set({ chatImage }),
  setIconShape: (iconShape: string | null) => set({ iconShape }),
  setIconSize: (iconSize: any) => set({ iconSize }),
  setDefaultTheme: (defaultTheme: string) => set({ defaultTheme }),
  setBrandColor: (brandColor: string) => set({ brandColor }),
  setInputBorderColor: (inputBorderColor: string) =>
    set({ inputBorderColor }),
  setFont: (font: string) => set({ font }),
  setFontWeight: (fontWeight: string) =>
    set({ fontWeight }),
  setPageBackground: (pageBackground: string) => set({ pageBackground }),
  setPageText: (pageText: string) => set({ pageText }),
  setBackgroundImage: (backgroundImage: string | null) =>
    set({ backgroundImage }),
  setResponseContainer: (responseContainer: string) =>
    set({ responseContainer }),
  setResponseText: (responseText: string) => set({ responseText }),
  setUserContainer: (userContainer: string) => set({ userContainer }),
  setUserText: (userText: string) => set({ userText }),
  // setGlobalData: data => set({ ...data }),
}));

export default storeThemeChat;
